<template>
    <d-card class="mt-3 mb-3">
        <d-card-header class="pb-0 mb-3">Connected integrations</d-card-header>
        <d-card-body v-if="integrations" class="p-0">
            <div class="dataTables_wrapper domain-table VueTables VueTables--client">
                <div class="table-responsive">
                    <table class="VueTables__table transaction-history table dataTable">
                        <thead>
                            <tr>
                                <th class="VueTables__sortable">
                                    <span title="" class="VueTables__heading"></span>
                                    <span class="VueTables__sort-icon pull-right glyphicon glyphicon-sort "></span>
                                </th>
                                <th class="VueTables__sortable network-table d-none d-lg-table-cell">
                                    <span title="" class="VueTables__heading">Integration</span>
                                    <span class="VueTables__sort-icon pull-right glyphicon glyphicon-sort "></span>
                                </th>
                                <th class="VueTables__sortable d-none d-lg-table-cell">
                                    <span title="" class="VueTables__heading">Connected on</span>
                                    <span class="VueTables__sort-icon pull-right glyphicon glyphicon-sort "></span>
                                </th>
                                <th class="VueTables__sortable">
                                    <span title="" class="VueTables__heading">Configured with</span>
                                    <span class="VueTables__sort-icon pull-right glyphicon glyphicon-sort "></span>
                                </th>
                                <th class="VueTables__sortable">
                                    <span title="" class="VueTables__heading">Status</span>
                                    <span class="VueTables__sort-icon pull-right glyphicon glyphicon-sort "></span>
                                </th>
                                <th class="VueTables__sortable">
                                    <span title="" class="VueTables__heading"></span>
                                    <span class="VueTables__sort-icon pull-right glyphicon glyphicon-sort "></span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="integrations.googleAnalyticsIntegration">
                                <td class="">
                                    <div class="sc-stats__image col" size="small">
                                        <img src="@/assets/images/sales-overview/google_analytics.svg" alt="User Avatar">
                                    </div>
                                </td>
                                <td class="network-table d-none d-lg-table-cell">
                                    Google Analytics
                                <td class="d-none d-lg-table-cell">
                                    {{ integrations.googleAnalyticsIntegration.created_at }}
                                </td>
                                <td>
                                    {{ integrations.googleAnalyticsIntegration.google_id }}
                                </td>
                                <td>
                                    <div class="col" size="small">
                                        <span class="badge badge-primary badge-pill badge-success">
                                            Connected
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div class="buttons col" size="small" v-if="checkPermission(permissionTypes.integrationWrite)">
                                        <d-link class="text-dark" :to="{ name: 'connect-integration' }"><i class="fa fa-pencil"></i></d-link>
                                        <confirm-message
                                            class="d-inline-block"
                                            message="You are about to delete your integration of Google Analytics	."
                                            keep-button-text="No, keep Google Analytics	"
                                            @confirm="disconnectIntegration('googleAnalytics')"
                                        >
                                            <i class="fas fa-trash ml-2"></i>
                                        </confirm-message>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="integrations.googleAnalyticsV4Integration">
                                <td class="">
                                    <div class="sc-stats__image col" size="small">
                                        <img src="../../components/integrations/google-analytics-v4/assets/ga-v4-mini.jpeg" alt="GA V4">
                                    </div>
                                </td>
                                <td class="network-table d-none d-lg-table-cell">
                                    Google Analytics V4
                                <td class="d-none d-lg-table-cell">
                                    {{ integrations.googleAnalyticsV4Integration.created_at }}
                                </td>
                                <td>
                                    {{ integrations.googleAnalyticsV4Integration.measurement_id }}
                                </td>
                                <td>
                                    <div class="col" size="small">
                                        <span class="badge badge-primary badge-pill badge-success">
                                            Connected
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div class="buttons col" size="small" v-if="checkPermission(permissionTypes.integrationWrite)">
                                        <d-link class="text-dark" :to="{ name: 'google-analytics-v4', params: { websiteId: this.$route.params.id } }">
                                            <i class="fa fa-pencil"></i>
                                        </d-link>
                                        <confirm-message
                                            class="d-inline-block"
                                            message="You are about to delete your integration of Google Analytics V4"
                                            keep-button-text="No, keep Google Analytics V4"
                                            @confirm="disconnectIntegration('googleAnalyticsV4')"
                                        >
                                            <i class="fas fa-trash ml-2"></i>
                                        </confirm-message>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="integrations.bingAdsIntegration">
                                <td class="">
                                    <div class="sc-stats__image col" size="small">
                                        <img src="@/assets/images/microsoft.svg" alt="microsoft">
                                    </div>
                                </td>
                                <td class="network-table d-none d-lg-table-cell">
                                    Microsoft Advertising
                                </td>
                                <td class="d-none d-lg-table-cell">
                                    {{ integrations.bingAdsIntegration.created_at }}
                                </td>
                                <td>
                                    {{ integrations.bingAdsIntegration.goal_name }}
                                </td>
                                <td class="">
                                    <div class="col" size="small">
                                        <span v-if="integrations.bingAdsIntegration.connection_status" class="badge badge-primary badge-pill badge-success">
                                            Connected
                                        </span>
                                        <span v-else class="badge badge-danger badge-pill">
                                            Reconnection needed
                                        </span>
                                    </div>
                                </td>
                                <td class="">
                                    <div class="buttons col" size="small" v-if="checkPermission(permissionTypes.integrationWrite)">
                                        <d-link class="text-dark" :to="{ name: 'connect-integration' }"><i class="fa fa-pencil"></i></d-link>
                                        <confirm-message
                                            class="d-inline-block"
                                            message="You are about to delete your integration of Microsoft Advertising."
                                            keep-button-text="No, keep Microsoft Advertising"
                                            @confirm="disconnectIntegration('bingAds')"
                                        >
                                            <i class="fas fa-trash ml-2"></i>
                                        </confirm-message>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="integrations.facebookIntegration">
                                <td class="">
                                    <div class="sc-stats__image col" size="small">
                                        <img src="@/assets/images/facebook.svg" alt="facebook">
                                    </div>
                                </td>
                                <td class="network-table d-none d-lg-table-cell">
                                    Facebook
                                </td>
                                <td class="d-none d-lg-table-cell">
                                    {{ integrations.facebookIntegration.created_at }}
                                </td>
                                <td>
                                    {{ integrations.facebookIntegration.pixel_id }}
                                </td>
                                <td class="">
                                    <div class="col" size="small">
                                        <span class="badge badge-primary badge-pill badge-success">
                                            Connected
                                        </span>
                                    </div>
                                </td>
                                <td class="">
                                    <div class="buttons col" size="small" v-if="checkPermission(permissionTypes.integrationWrite)">
                                        <d-link class="text-dark" :to="{ name: 'connect-integration' }"><i class="fa fa-pencil"></i></d-link>
                                        <confirm-message
                                            class="d-inline-block"
                                            message="You are about to delete your integration of Facebook."
                                            keep-button-text="`No, keep Facebook"
                                            @confirm="disconnectIntegration('facebook')"
                                        >
                                            <i class="fas fa-trash ml-2"></i>
                                        </confirm-message>

                                    </div>
                                </td>
                            </tr>
                            <tr v-if="integrations.keuzeNLIntegration">
                                <td class="">
                                    <div class="sc-stats__image col" size="small">
                                        <img src="@/assets/images/keuze.svg" alt="keuze">
                                    </div>
                                </td>
                                <td class="network-table d-none d-lg-table-cell">
                                    Keuze.NL
                                </td>
                                <td class="d-none d-lg-table-cell">
                                    {{ integrations.keuzeNLIntegration.created_at }}
                                </td>
                                <td>
                                    &nbsp;
                                </td>
                                <td class="">
                                    <div class="col" size="small">
                                        <span class="badge badge-primary badge-pill badge-success">
                                            Connected
                                        </span>
                                    </div>
                                </td>
                                <td class="">
                                    <div class="buttons col" size="small" v-if="checkPermission(permissionTypes.integrationWrite)">
                                        <confirm-message
                                            class="d-inline-block"
                                            message="You are about to delete your integration of Keuze.NL."
                                            keep-button-text="`No, keep Keuze.NL"
                                            @confirm="disconnectIntegration('knl')"
                                        >
                                            <i class="fas fa-trash ml-2"></i>
                                        </confirm-message>

                                    </div>
                                </td>
                            </tr>
                            <tr v-if="integrations.kiziNLIntegration">
                                <td class="">
                                    <div class="sc-stats__image col" size="small">
                                        <img src="@/assets/images/kizi.png" alt="kizi">
                                    </div>
                                </td>
                                <td class="network-table d-none d-lg-table-cell">
                                    Kizi.NL
                                </td>
                                <td class="d-none d-lg-table-cell">
                                    {{ integrations.kiziNLIntegration.created_at }}
                                </td>
                                <td>
                                    &nbsp;
                                </td>
                                <td class="">
                                    <div class="col" size="small">
                                        <span class="badge badge-primary badge-pill badge-success">
                                            Connected
                                        </span>
                                    </div>
                                </td>
                                <td class="">
                                    <div class="buttons col" size="small" v-if="checkPermission(permissionTypes.integrationWrite)">
                                        <confirm-message
                                            class="d-inline-block"
                                            message="You are about to delete your integration of Kizi.NL."
                                            keep-button-text="`No, keep Kizi.NL"
                                            @confirm="disconnectIntegration('knl')"
                                        >
                                            <i class="fas fa-trash ml-2"></i>
                                        </confirm-message>

                                    </div>
                                </td>
                            </tr>
                            <tr v-if="integrations.kickbiteIntegration">
                                <td class="">
                                    <div class="sc-stats__image col" size="small">
                                        <img src="@/assets/images/kickbite-mini.svg" alt="kickbite">
                                    </div>
                                </td>
                                <td class="network-table d-none d-lg-table-cell">
                                    Kickbite
                                </td>
                                <td class="d-none d-lg-table-cell">
                                    {{ integrations.kickbiteIntegration.created_at }}
                                </td>
                                <td>
                                    {{ integrations.kickbiteIntegration.app_id }}
                                </td>
                                <td class="">
                                    <div class="col" size="small">
                                        <span class="badge badge-primary badge-pill badge-success">
                                            Connected
                                        </span>
                                    </div>
                                </td>
                                <td class="">
                                    <div class="buttons col" size="small" v-if="checkPermission(permissionTypes.integrationWrite)">
                                        <d-link class="text-dark" :to="{ name: 'connect-integration' }"><i class="fa fa-pencil"></i></d-link>
                                        <confirm-message
                                            class="d-inline-block"
                                            message="You are about to delete your integration of Kickbite."
                                            keep-button-text="`No, keep Kickbite"
                                            @confirm="disconnectIntegration('kickbite')"
                                        >
                                            <i class="fas fa-trash ml-2"></i>
                                        </confirm-message>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </d-card-body>
        <d-card-footer v-if="checkPermission(permissionTypes.integrationWrite)" class="d-flex justify-content-end">
            <d-link tag="button" :to="{ name: 'connect-integration' }" class="btn mb-2 mr-1 btn-success"><i class="fas fa-plus"></i>  Connect new integrations</d-link>
        </d-card-footer>
    </d-card>
</template>

<script>
    import { UserService, WebsiteService, GoogleAnalyticsOAuthService } from '@/main';
    import notification from '@/mixins/notification';
    import ConfirmMessage from '@/components/common/confirmMessage.vue';
    import ConfigurationList from '@/components/ga-v4/ConfigurationList.vue';
    import permissions from '../../mixins/permissions';

    export default {
        mixins: [notification, permissions],
        components: {
            ConfirmMessage,
            ConfigurationList
        },

        data() {
            return {
                columnsIntegrations: ['logo', 'integration', 'created_at', 'goal_name', 'status', 'buttons'],
                /**
                * Vue Tables Configuration Options
                * @see https://github.com/matfish2/vue-tables-2
                */
                clientTableOptions: {
                    perPage: 25,
                    childRowTogglerFirst: false,
                    recordsPerPage: [25, 50, 100],
                    skin: 'transaction-history table dataTable',
                    filterable: false,
                    texts: {
                        limit: 'Show',
                    },
                    columnsDisplay: {
                        status: 'desktop',
                        transaction: 'desktop',
                        connected: 'desktop',
                        configured: 'desktop',
                    },
                    columnsClasses: {
                        network: 'network-table',
                        transaction: 'network-table',
                        integration: 'network-table',
                        connected: 'network-table',
                        configured: 'network-table',
                    },
                    headings: {
                        logo: '',
                        network: 'Network',
                        created_at: 'Connected on',
                        transaction: 'Last transaction',
                        status: 'Status',
                        buttons: '',
                        integration: 'Integration',
                        goal_name: 'Configured with',
                    },
                },

                integrations: null
            };
        },

        methods: {
            async getIntegrations() {
                this.integrations = await UserService.getIntegrations(this.$route.params.id)
            },

            async disconnectIntegration(integration) {
                try {
                    if (integration === 'googleAnalytics' && this.integrations.hasGoogleConnection) {
                        await GoogleAnalyticsOAuthService.removeGoogle(this.$route.params.id)
                    }
                    await WebsiteService.disconnectIntegration(this.$route.params.id, integration)
                    this.showNotification('success', 'Alert', 'Integration successfully disconnected!')
                    this.$router.go()
                } catch(e) {
                    this.showNotification('warn', 'Oops! we have a problem', 'Can not remove integration')
                    console.log(e)
                }
            },
        },

        created () {
            this.getIntegrations()
        },

        watch: {
            $route(to, from) {
                this.getIntegrations()
            }
        },
    };
    </script>
